var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSort(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "silver",
    d: "M4.014 11.758l-.055.052c-.11.12-.275.19-.459.19s-.35-.07-.478-.19L.192 9.013c-.256-.259-.256-.673 0-.932.258-.26.68-.26.938 0l1.709 1.674V.622C2.839.276 3.133 0 3.5 0c.367 0 .661.276.661.622v9.133l1.71-1.674c.256-.26.679-.26.936 0 .257.259.257.673 0 .932l-2.793 2.745z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.2978689f.svg";
export { ForwardRef as ReactComponent };